module.exports = "<label class=nn-base-field-label ng-transclude></label>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-field-label/nn-base-field-label.directive.html
// module id = 953
// module chunks = 0